import React from "react";

type Props = {
  left: React.ReactNode;
  right: React.ReactNode;
};

export const DesktopJourneyFareLayout: React.FC<Props> = ({ left, right }) => {
  return (
    <div
      className="wa-cluster wa-gap-l wa-align-start"
      style={{ alignItems: "stretch", flexWrap: "wrap" }}
    >
      <div style={{ flex: "1 1 420px", minWidth: 320 }}>{left}</div>
      <div style={{ flex: "1 1 420px", minWidth: 320 }}>{right}</div>
    </div>
  );
};
